// Localized site content (EN / FI). Static copy lives here so the language
// switcher can translate every visible string on the public site.

export const BRAND_L = {
  tagline: {
    en: "Parametric 3D Wood Panels & Architectural Surfaces",
    fi: "Parametriset 3D-puupaneelit ja arkkitehtoniset pinnat",
  },
  meta: {
    en: "[ 01 // HELSINKI & ISTANBUL PRODUCTION STUDIO ]",
    fi: "[ 01 // HELSINGIN JA ISTANBULIN TUOTANTOSTUDIO ]",
  },
  philosophy: {
    en: "Ecological, sustainable design forms the foundation of our design philosophy.",
    fi: "Ekologinen ja kestävä muotoilu on suunnittelufilosofiamme perusta.",
  },
  quote: {
    en: "Where the spirit does not work with the hand, there is no art.",
    fi: "Missä henki ei työskentele käden kanssa, siellä ei ole taidetta.",
  },
};

export const STATS_L = [
  { value: "2009", label: { en: "Founded", fi: "Perustettu" } },
  { value: "420+", label: { en: "Projects delivered", fi: "Toteutettuja projekteja" } },
  { value: "2", label: { en: "Production studios", fi: "Tuotantostudiota" } },
  { value: "38k m²", label: { en: "Panels milled", fi: "Jyrsittyä paneelia" } },
];

export const SERVICES_L = [
  {
    no: "01",
    title: { en: "Parametric 3D Wall Panels", fi: "Parametriset 3D-seinäpaneelit" },
    text: {
      en: "Algorithmically generated relief surfaces milled from solid birch, oak and ash. Each module is nested, numbered and delivered as a click-fit system.",
      fi: "Algoritmisesti luodut reliefipinnat jyrsitään massiivikoivusta, tammesta ja saarnesta. Jokainen moduuli on nestattu, numeroitu ja toimitetaan klikkijärjestelmänä.",
    },
    points: {
      en: ["Grasshopper / Rhino modelling", "5-axis CNC milling", "Seamless module tiling"],
      fi: ["Grasshopper / Rhino -mallinnus", "5-akselinen CNC-jyrsintä", "Saumaton moduulitoisto"],
    },
  },
  {
    no: "02",
    title: { en: "Acoustic Surface Systems", fi: "Akustiset pintajärjestelmät" },
    text: {
      en: "Slat, perforated and micro-grooved acoustic panels with class A absorbers. Tested absorption values from αw 0.55 to 0.95.",
      fi: "Säle-, rei'itetyt ja mikrouritetut akustiikkapaneelit A-luokan absorboijilla. Testatut absorptioarvot αw 0,55 - 0,95.",
    },
    points: {
      en: ["Slat-on-felt systems", "Perforated MDF & veneer", "Acoustic reports"],
      fi: ["Säle-huopajärjestelmät", "Rei'itetty MDF ja viilu", "Akustiikkaraportit"],
    },
  },
  {
    no: "03",
    title: { en: "CNC Wood Cladding", fi: "CNC-puuverhoukset" },
    text: {
      en: "Interior and ventilated exterior cladding in thermally modified timber, with concealed fixing rails and full shop drawings.",
      fi: "Sisä- ja tuuletetut ulkoverhoukset lämpökäsitellystä puusta, piilokiinnitysreiloilla ja täydellisillä työpiirustuksilla.",
    },
    points: {
      en: ["Thermo-ash & thermo-pine", "Concealed clip rails", "Fire-retardant options"],
      fi: ["Lämpösaarni ja lämpömänty", "Piilokiinnitysreilat", "Palonsuojatut vaihtoehdot"],
    },
  },
  {
    no: "04",
    title: { en: "Architectural Woodwork & Joinery", fi: "Arkkitehtoninen puusepäntyö" },
    text: {
      en: "High-end bespoke joinery for hospitality, retail and residential interiors, from reception monoliths to full library walls.",
      fi: "Korkealuokkaista mittatilauspuusepäntyötä hotelli-, myymälä- ja asuintiloihin, vastaanottomonoliiteista kokonaisiin kirjastoseiniin.",
    },
    points: {
      en: ["Bespoke millwork", "Veneer matching", "On-site installation"],
      fi: ["Mittatilaustyöt", "Viilun sovitus", "Asennus paikan päällä"],
    },
  },
  {
    no: "05",
    title: { en: "Interior Architecture & Design", fi: "Sisustusarkkitehtuuri ja suunnittelu" },
    text: {
      en: "Since 2009 we deliver complete architectural and interior design services, from needs analysis to construction documentation.",
      fi: "Vuodesta 2009 olemme tuottaneet kokonaisvaltaisia arkkitehti- ja sisustussuunnittelupalveluita tarveanalyysistä rakennusdokumentaatioon.",
    },
    points: {
      en: ["Concept & space planning", "3D visualisation", "Technical detailing"],
      fi: ["Konsepti ja tilasuunnittelu", "3D-visualisointi", "Tekninen detaljointi"],
    },
  },
  {
    no: "06",
    title: { en: "Project Management & Supervision", fi: "Projektinhallinta ja valvonta" },
    text: {
      en: "Budget planning, tender packages with quantity take-offs and periodic site supervision until handover.",
      fi: "Budjetointi, tarjouspyyntöaineistot määrälaskelmineen ja määräaikainen työmaavalvonta luovutukseen asti.",
    },
    points: {
      en: ["Tender packages", "Cost planning", "Site supervision"],
      fi: ["Tarjousaineistot", "Kustannussuunnittelu", "Työmaavalvonta"],
    },
  },
];

export const PROCESS_L = [
  {
    no: "01",
    title: { en: "Needs Analysis", fi: "Tarveanalyysi" },
    text: {
      en: "Knowing you well is the most important step of the project. We evaluate the analysis of the space and develop the spatial narrative accordingly.",
      fi: "Sinun tunteminen on projektin tärkein askel. Arvioimme tilan analyysin ja kehitämme tilallisen tarinan sen mukaan.",
    },
  },
  {
    no: "02",
    title: { en: "Design", fi: "Suunnittelu" },
    text: {
      en: "Once the layout is clear we move to the most enjoyable part. We share 3D visuals and physical samples of the environmentally sound materials we select.",
      fi: "Kun pohjaratkaisu on selvä, siirrymme nautinnollisimpaan osaan. Jaamme 3D-kuvat ja fyysiset mallit valitsemistamme ympäristöystävällisistä materiaaleista.",
    },
  },
  {
    no: "03",
    title: { en: "Project", fi: "Projektointi" },
    text: {
      en: "Budget and construction schedules are planned. Correct budgeting and optimum build time prevent both time and cash loss.",
      fi: "Budjetti ja rakennusaikataulut suunnitellaan. Oikea budjetointi ja optimaalinen rakennusaika estävät sekä ajan että rahan menetyksen.",
    },
  },
  {
    no: "04",
    title: { en: "Production", fi: "Tuotanto" },
    text: {
      en: "Nesting, 5-axis milling, sanding and finishing in our own studio. Every module is numbered against the installation drawing.",
      fi: "Nestaus, 5-akselinen jyrsintä, hionta ja viimeistely omassa studiossamme. Jokainen moduuli numeroidaan asennuspiirustuksen mukaan.",
    },
  },
  {
    no: "05",
    title: { en: "Application", fi: "Toteutus" },
    text: {
      en: "We install with all trades organised, or prepare a tender package with quantity lists. We can also take on site supervision only.",
      fi: "Asennamme kaikkien työvaiheiden kanssa, tai laadimme tarjousaineiston määräluetteloineen. Voimme ottaa myös pelkän työmaavalvonnan.",
    },
  },
];

export const ABOUT_TEXT_L = [
  {
    en: "HRD has been providing architectural and interior design and application services since 2009. With our young and dynamic structure we follow the changing technologies of the world and produce projects that answer the needs of our clients.",
    fi: "HRD on tuottanut arkkitehti- ja sisustussuunnittelun sekä toteutuksen palveluita vuodesta 2009. Nuoren ja dynaamisen rakenteemme ansiosta seuraamme maailman muuttuvia teknologioita ja tuotamme projekteja, jotka vastaavat asiakkaidemme tarpeisiin.",
  },
  {
    en: "We know that qualified design emerges from the combination of many factors, and for this reason we evaluate every project according to its own data to produce functional, original designs. These factors cover communication with the client, needs analysis and functional use, material selection and original design, financial budget and application periods.",
    fi: "Tiedämme, että laadukas suunnittelu syntyy monen tekijän yhdistelmästä, ja siksi arvioimme jokaisen projektin sen omien lähtötietojen mukaan tuottaen toimivia ja omaperäisiä ratkaisuja. Näihin tekijöihin kuuluvat asiakasviestintä, tarveanalyysi ja toiminnallinen käyttö, materiaalivalinnat ja omaperäinen muotoilu, budjetti sekä toteutusaikataulut.",
  },
  {
    en: "Today our focus is primary manufacturing: we are makers of 3D parametric wood wall panels, custom CNC wood cladding and acoustic surface panels, produced between our Helsinki (Finland) and Istanbul (Türkiye) studios.",
    fi: "Tänään painopisteemme on valmistuksessa: teemme parametrisia 3D-puuseinäpaneeleita, mittatilaus-CNC-puuverhouksia ja akustisia pintapaneeleita Helsingin (Suomi) ja Istanbulin (Türkiye) studioissamme.",
  },
];

export const TEAM_L = [
  {
    name: "Hüseyin Demirkundak",
    role: { en: "Interior Architect / Founding Partner", fi: "Sisustusarkkitehti / Perustajaosakas" },
    bio: {
      en: "Graduated in Interior Architecture from Pera Academy of Fine Arts, then continued at Palazzo Spinelli Academy, Florence. Took part in many projects at home and abroad. Working at HRD since 2009. Professional photography, model aircraft and sailing are his hobbies.",
      fi: "Valmistui sisustusarkkitehdiksi Pera Academy of Fine Artsista ja jatkoi Palazzo Spinelli -akatemiassa Firenzessä. Osallistunut lukuisiin projekteihin kotimaassa ja ulkomailla. Työskennellyt HRD:ssä vuodesta 2009. Harrastuksina valokuvaus, pienoislentokoneet ja purjehdus.",
    },
    image: "https://www.hrdmimarlik.com/images/hakkimizda/huseyin-demirkundak.jpeg",
    portrait: "https://images.unsplash.com/photo-1598367815092-a2c0cbc1ea3d",
  },
  {
    name: "Reyhan Demirkundak",
    role: { en: "Architect / Founding Partner", fi: "Arkkitehti / Perustajaosakas" },
    bio: {
      en: "Graduated from the Faculty of Architecture at Trakya University, then continued her education at Palazzo Spinelli Academy, Florence. Took part in many, mainly domestic, projects. Continues design and application work at HRD since 2009. Her favourite thing is being a part-time traveller.",
      fi: "Valmistui Trakyan yliopiston arkkitehtuurin tiedekunnasta ja jatkoi opintojaan Palazzo Spinelli -akatemiassa Firenzessä. Osallistunut lukuisiin, pääosin kotimaisiin projekteihin. Jatkaa suunnittelu- ja toteutustyötä HRD:ssä vuodesta 2009. Rakkain asia on osa-aikainen matkustaminen.",
    },
    image: "https://www.hrdmimarlik.com/images/hakkimizda/reyhan-demirkundak_1.jpeg",
    portrait: "https://images.unsplash.com/photo-1744686909434-fd158fca1c35",
  },
];

export const PRODUCT_LINES_L = [
  {
    id: "match",
    tag: "01",
    name: "MATCH Collection 2026",
    family: { en: "Modular Surface Collection / CNC Panels", fi: "Modulaarinen pintakokoelma / CNC-paneelit" },
    text: {
      en: "A CNC-routed modular surface system engineered for 6 mm MDF. Repeat, rotate and match panels into one continuous architectural surface.",
      fi: "CNC-jyrsitty modulaarinen pintajärjestelmä 6 mm MDF-levylle. Toista, kierrä ja yhdistä paneelit yhdeksi jatkuvaksi arkkitehtoniseksi pinnaksi.",
    },
    image: "/match/kaari.jpg",
    specs: ["6 mm MDF", "4 series", "24-panel layouts"],
    to: "/products",
  },
  {
    id: "acoustic",
    tag: "02",
    name: "Acoustic Surface Systems",
    family: { en: "Slat & perforated absorbers", fi: "Säle- ja rei'itetyt absorboijat" },
    text: {
      en: "Slat-on-felt, perforated and micro-grooved acoustic panels with recycled PET backing. Tested absorption from αw 0.55 to 0.95.",
      fi: "Säle-huopa-, rei'itetyt ja mikrouritetut akustiikkapaneelit kierrätetyllä PET-taustalla. Testattu absorptio αw 0,55 - 0,95.",
    },
    image: "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5?w=1600&q=80&auto=format&fit=crop",
    specs: ["Ash / Birch", "21 mm", "αw 0.90"],
    to: "/products",
  },
  {
    id: "cladding",
    tag: "03",
    name: "CNC Wood Cladding",
    family: { en: "Interior & ventilated facade", fi: "Sisätila ja tuuletettu julkisivu" },
    text: {
      en: "Fluted and profiled cladding in thermally modified timber with concealed clip rails, delivered with full shop drawings.",
      fi: "Uritetut ja profiloidut verhoukset lämpökäsitellystä puusta piilokiinnitysreiloilla, täydellisin työpiirustuksin.",
    },
    image: "https://images.unsplash.com/photo-1543646269-fcc4ba67ac5f?w=1600&q=80&auto=format&fit=crop",
    specs: ["Thermo Ash", "25 mm", "Rainscreen"],
    to: "/products",
  },
];
